import BlockIcon from "@mui/icons-material/Block"
import { CircularProgress, Tooltip } from "@mui/material"
import styles from "./PhoneNumbers.module.scss"
import { getFormattedPhoneNumber } from "@web/components/Forms"

interface PhoneNumbersContentProps {
  canDoContactInfoLookup: boolean
  isLoading: boolean
  fetchedPhoneNumber?: string
}

export const PhoneNumbersContent = ({
  canDoContactInfoLookup,
  isLoading,
  fetchedPhoneNumber,
}: PhoneNumbersContentProps) => {
  const showPhoneNumber = canDoContactInfoLookup && !isLoading

  const showPaymentRequired = !canDoContactInfoLookup
  if (showPaymentRequired)
    return (
      <Tooltip title="Please update to find more phone numbers" classes={{ tooltip: "!tmb-text-[14px]" }}>
        <div className="tmb-flex tmb-flex-row tmb-gap-1 tmb-items-center tmb-my-2">
          <BlockIcon className="tmb-text-white tmb-h-5" />
          <span className="tmb-text-base tmb-text-white tmb-font-sans">Phone numbers search</span>
        </div>
      </Tooltip>
    )

  const showLoading = canDoContactInfoLookup && isLoading
  if (showLoading)
    return (
      <>
        Loading number
        <CircularProgress className={styles.spinner} />
      </>
    )

  if (showPhoneNumber && fetchedPhoneNumber) return <>Use {getFormattedPhoneNumber(fetchedPhoneNumber)}</>

  return <>No numbers found</>
}
